module.exports = __webpack_public_path__ + "static/media/unilu.dc42d09c.jpg";